<app-page-header></app-page-header>
<app-breadcromb pageName="Applicant Referees"></app-breadcromb>
<!-- Candidate Dashboard Area Start -->
<section class="candidate-dashboard-area section_70">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-12 dashboard-left-border">
                <div class="dashboard-left">
                    <app-client-dashboard-sidebar></app-client-dashboard-sidebar>
                </div>
            </div>
            <div class="col-lg-9 col-md-12">
                <div class="dashboard-right">
                    <div class="candidate-profile">
                        <div class="candidate-single-profile-info">
                            <form #userForm="ngForm" (ngSubmit)="onSubmit(userForm.value)">
                                <div class="resume-box">
                                    <h3>Referees</h3>
                                    <div>
                                        <div class="single-resume-feild feild-flex-2">
                                            <div class="single-input">
                                                <label for="Email">Name: </label><span class="ng-star-inserted"> *</span>
                                                <input required #name="ngModel" ngModel type="text" maxlength="254" name="name">
                                                <span *ngIf="name.invalid && name.touched" class="error" style="color: red;">Name is required</span>
                                            </div>
                                            <div class="single-input">
                                                <label for="Phone">Institution/Company:  </label><span class="ng-star-inserted"> *</span>
                                                <input required #company="ngModel" ngModel type="text" maxlength="254" name="company">
                                                <span *ngIf="company.invalid && company.touched" class="error" style="color: red;">Company/Institution is required</span>
                                            </div>
                                            <div class="single-input">
                                                <label for="Email">Job Title: </label><span class="ng-star-inserted"> *</span>
                                                <input required #title="ngModel" ngModel type="text" maxlength="254" name="position">
                                                <span *ngIf="title.invalid && title.touched" class="error" style="color: red;">Title is required</span>
                                            </div>
                                        </div>
                                        <div class="single-resume-feild feild-flex-2">
                                            <div class="single-input">
                                                <label for="Phone">Relationship:  </label><span class="ng-star-inserted"> *</span>
                                                <input required #rela="ngModel" ngModel type="text" maxlength="254" name="relationship">
                                                <span *ngIf="rela.invalid && rela.touched" class="error" style="color: red;">Relationship is required</span>
                                            </div>
                                            <div class="single-input">
                                                <label for="Email">Cell: </label><span class="ng-star-inserted"> *</span>
                                                <input required #cell="ngModel" ngModel type="text" maxlength="254" name="cell">
                                                <span *ngIf="cell.invalid && cell.touched" class="error" style="color: red;">Cell is required</span>
                                            </div>
                                            <div class="single-input">
                                                <label for="Email">Email: </label><span class="ng-star-inserted"> *</span>
                                                <input pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,6}" required #email="ngModel" ngModel type="email" name="email">
                                                <span *ngIf="email.invalid && email.touched" class="error" style="color: red;">Email is required</span>
                                            </div>
                                        </div>
                                        <div class="single-resume-feild feild-flex-2">
                                            <div class="single-input">
                                                <label for="Email">Address: </label><span class="ng-star-inserted"> *</span>
                                                <textarea required #addr="ngModel" ngModel name="address"></textarea>
                                                <span *ngIf="addr.invalid && addr.touched" class="error" style="color: red;">Address is required</span>
                                            </div>
                                        </div>
                                        <div class="single-resume-feild feild-flex-2">
                                            <div class="single-input">
                                                <hr>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="submit-resume">
                                    <button [disabled]="userForm.invalid" class="btn btn-success">Save</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Candidate Dashboard Area End -->